import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillGroup, BillFile } from '../../models';
import { BillTypeBadgeComponent } from './bill-type-badge.component';

@Component({
  selector: 'app-bill-group-card',
  standalone: true,
  imports: [CommonModule, BillTypeBadgeComponent],
  templateUrl: './bill-group-card.component.html',
  styleUrl: './bill-group-card.component.scss'
})
export class BillGroupCardComponent {
    @Input() group!: BillGroup;
    @Output() onEdit = new EventEmitter<BillFile>();
    @Output() onView = new EventEmitter<BillFile>();

    isPaired(): boolean {
        return this.group.utilityBill !== null && this.group.supplierBill !== null;
    }

    formatDate(dateStr: string): string {
        if (!dateStr) return '—';
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return dateStr;
        return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }

    getCardClass(): string {
        if (this.isPaired()) {
            switch (this.group.matchConfidence) {
                case 'high': return 'high-confidence';
                case 'medium': return 'medium-confidence';
                case 'low': return 'low-confidence';
            }
        }
        return '';
    }

    getConfidenceLabel(): string {
        switch (this.group.matchConfidence) {
            case 'high': return 'Matched';
            case 'medium': return 'Likely Match';
            case 'low': return 'Possible Match';
            default: return 'Unpaired';
        }
    }
}
